// // // /* eslint-disable @typescript-eslint/no-explicit-any */
// // // // // @ts-nocheck
// // // // // import { store } from '../store/index';
// // // // // import { refreashToken } from '../store/Login/loginSlice.js';
// // // // import axios from 'axios';
// // // // import { variables } from './variables.ts';
// // // // import { IsTokenValid } from '../Helper/Helper';
// // // // import { DecryptString } from '../Helper/Encrypt/NtxEncrypt';
// // // // import { store } from '@store/index.ts';

// // // // const AuthUser = localStorage?.AuthUser ? JSON.parse(DecryptString(localStorage?.AuthUser)) : null;
// // // // //
// // // // export const ntxAPI = axios.create({
// // // //   baseURL: variables.API_URL,
// // // //   headers: variables.ntxheader
// // // // });

// // // // let isRefreshing = false;
// // // // let refreshQueue = [];

// // // // ntxAPI.interceptors.request.use(async req => {
// // // //   const Token = store.getState()?.userLogin?.AuthUser?.token;
// // // //   // const Token =
// // // //   //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiIyZDg3NWJjZS1lN2JjLTRkZjAtYmU5NC0zNWMyYzliNzM1NGUiLCJVc2VyTmFtZSI6ImhhcmV0aCIsIkJ1c2luZXNzR3JvdXBJZCI6IjAwMDAwMDAwLTExMTEtMjIyMi0zMzMzLWFhYWFhYWFhYWEwMCIsIlBlcm1pc3Npb24iOiIvLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vSHc9PSIsIkp0aSI6IjNhY2RkYzU1LWQxMDMtNDRhOS1iMTNjLTk2NWQ2NjUyZDFlNyIsImV4cCI6Mzc3NTQ5MTc1OTQsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwIiwiYXVkIjoiaHR0cDovL2xvY2FsaG9zdDo0MDAifQ.4BX4MRd4yRMoR3ECpmTWP76kBv7TY99U1reUJk5LBqM';
// // // //   // const Token = AuthUser?.token;
// // // //   req.headers.Authorization = `Bearer ${Token}`;

// // // //   if (IsTokenValid()) {
// // // //     return req;
// // // //   }

// // // //   if (!isRefreshing) {
// // // //     isRefreshing = true;

// // // //     try {
// // // //       const newToken = await refreshToken();
// // // //       if (newToken) {
// // // //         req.headers.Authorization = `Bearer ${newToken}`;
// // // //         refreshQueue.forEach(resolve => resolve(newToken));
// // // //       }
// // // //     } finally {
// // // //       isRefreshing = false;
// // // //       refreshQueue = [];
// // // //     }
// // // //   } else {
// // // //     return new Promise(resolve => {
// // // //       refreshQueue.push(newToken => {
// // // //         req.headers.Authorization = `Bearer ${newToken}`;
// // // //         resolve(req);
// // // //       });
// // // //     });
// // // //   }

// // // //   return req;
// // // // });

// // // // const refreshToken = async () => {
// // // //   try {
// // // //     const response = await axios.post(
// // // //       variables.API_URL + 'Authenticate/refresh-token',
// // // //       {
// // // //         accessToken: AuthUser?.token,
// // // //         refreshToken: AuthUser?.refreshToken,
// // // //         businessGroupId: AuthUser?.businessGroupId || null
// // // //       },
// // // //       {
// // // //         headers: variables.ntxheader
// // // //       }
// // // //     );

// // // //     return response.data.token;
// // // //   } catch (error) {
// // // //     console.log('Token refresh failed:', error);
// // // //     localStorage.clear();
// // // //     window.location.replace('/login');
// // // //     return null;
// // // //   }
// // // // };

// // // import axios from 'axios';
// // // import { variables } from './variables';
// // // import { isTokenValid } from '../Helper/Helper';
// // // import { DecryptString } from '../Helper/Encrypt/NtxEncrypt';
// // // import { store } from '@store/index';

// // // const AuthUser = localStorage?.AuthUser ? JSON.parse(DecryptString(localStorage?.AuthUser)) : null;



// // // export const ntxAPI = axios.create({
// // //   baseURL: variables.API_URL,
// // //   headers: variables.ntxheader,
// // //   withCredentials: true,
// // // });

// // // let isRefreshing = false;
// // // let refreshQueue: ((token: string) => void)[] = [];

// // // ntxAPI.interceptors.request.use(async (req: any) => {
// // //   const Token = store.getState()?.userLogin?.AuthUser?.token;

// // //   if (Token) {
// // //     req.headers = req.headers || {};
// // //     req.headers.Authorization = `Bearer ${Token}`;
// // //   }

// // //   if (isTokenValid()) {
// // //     return req;
// // //   }

// // //   if (!isRefreshing) {
// // //     isRefreshing = true;

// // //     try {
// // //       const newToken = await refreshToken();
// // //       if (newToken && req.headers) {
// // //         req.headers.Authorization = `Bearer ${newToken}`;
// // //         refreshQueue.forEach(resolve => resolve(newToken));
// // //       }
// // //     } finally {
// // //       isRefreshing = false;
// // //       refreshQueue = [];
// // //     }
// // //   } else {
// // //     return new Promise<any>(resolve => {
// // //       refreshQueue.push((newToken: string) => {
// // //         if (req.headers) {
// // //           req.headers.Authorization = `Bearer ${newToken}`;
// // //         }
// // //         resolve(req);
// // //       });
// // //     });
// // //   }

// // //   return req;
// // // });

// // // const refreshToken = async (): Promise<string | null> => {
// // //   try {
// // //      const response = await axios.post(
// // //       variables.API_URL + 'Authenticate/refresh-token',
// // //       {
// // //         accessToken: AuthUser?.token,
// // //         // refreshToken: AuthUser?.refreshToken,
// // //         businessGroupId: AuthUser?.businessGroupId || null
// // //       },
// // //       {
// // //         headers: variables.ntxheader
// // //       }
// // //     );

// // //     return response.data.token;
// // //   } catch (error) {
// // //     console.log('Token refresh failed:', error);
// // //     localStorage.removeItem('AuthUser');
// // //     window.location.replace('/login');
// // //     return null;
// // //   }
// // // };

// // import axios from 'axios';
// // import { variables } from './variables';
// // import { isTokenValid } from '../Helper/Helper';
// // import { DecryptString, EncryptString } from '../Helper/Encrypt/NtxEncrypt'; // يجب التأكد من استيراد EncryptString

// // // 1. دالة لقراءة وفك تشفير الـ AuthUser من localStorage عند كل استدعاء
// // const getAuthUser = () => {
// //   try {
// //     const raw = localStorage?.AuthUser;
// //     if (!raw) return null;
// //     return JSON.parse(DecryptString(raw));
// //   } catch {
// //     return null; // في حالة فشل القراءة أو فك التشفير
// //   }
// // };

// // export const ntxAPI = axios.create({
// //   baseURL: variables.API_URL,
// //   headers: variables.ntxheader,
// //   withCredentials: true,
// // });

// // let isRefreshing = false;
// // let refreshQueue: ((token: string) => void)[] = [];

// // ntxAPI.interceptors.request.use(async (req: any) => {
// //   // 2. الحصول على AuthUser والتوكن من localStorage
// //   const authUser = getAuthUser();
// //   const Token = authUser?.token;

// //   if (Token) {
// //     req.headers = req.headers || {};
// //     req.headers.Authorization = `Bearer ${Token}`;
// //   }

// //   // لو التوكن صالح لا حاجة للـ refresh
// //   if (isTokenValid()) {
// //     return req;
// //   }

// //   // لو غير صالح نبدأ منطق الـ refresh
// //   if (!isRefreshing) {
// //     isRefreshing = true;

// //     try {
// //       const newToken = await refreshToken();
// //       if (newToken && req.headers) {
// //         req.headers.Authorization = `Bearer ${newToken}`;
// //         // ننفذ جميع الطلبات التي تنتظر التوكن الجديد
// //         refreshQueue.forEach(resolve => resolve(newToken));
// //       }
// //     } finally {
// //       isRefreshing = false;
// //       refreshQueue = [];
// //     }
// //   } else {
// //     // لو فيه عملية refresh شغالة نضيف الطلب في الطابور
// //     return new Promise<any>(resolve => {
// //       refreshQueue.push((newToken: string) => {
// //         if (req.headers) {
// //           req.headers.Authorization = `Bearer ${newToken}`;
// //         }
// //         resolve(req);
// //       });
// //     });
// //   }

// //   return req;
// // });

// // // 3. دالة تحديث التوكن مع استخدام localStorage وقراءة refreshToken
// // const refreshToken = async (): Promise<string | null> => {
// //   const authUser = getAuthUser();

// //   // التأكد من وجود البيانات اللازمة لـ refresh
// //   if (!authUser?.token || !authUser?.refreshToken) {
// //     console.log('Token or RefreshToken not found in localStorage');
// //     localStorage.removeItem('AuthUser');
// //     window.location.replace('/login');
// //     return null;
// //   }

// //   try {
// //     const response = await axios.post(
// //       variables.API_URL + 'Authenticate/refresh-token',
// //       {
// //         accessToken: authUser.token,
// //         refreshToken: authUser.refreshToken, // استخدام refreshToken من localStorage
// //         businessGroupId: authUser.businessGroupId || null
// //       },
// //       {
// //         headers: variables.ntxheader
// //       }
// //     );

// //     // افتراض: الـ response يحتوي على البيانات المحدّثة (token, refreshToken, إلخ.)
// //     const newAuthUser = {
// //       ...authUser,
// //       ...response.data
// //     };

// //     // نحدّث AuthUser في localStorage بالتشفير
// //     localStorage.setItem('AuthUser', EncryptString(JSON.stringify(newAuthUser)));

// //     return response.data.token;
// //   } catch (error) {
// //     console.log('Token refresh failed:', error);
// //     localStorage.removeItem('AuthUser');
// //     window.location.replace('/login');
// //     return null;
// //   }
// // };



// import axios from 'axios';
// import { variables } from './variables';
// import { isTokenValid } from '../Helper/Helper';
// import { DecryptString } from '../Helper/Encrypt/NtxEncrypt';

// // ⚠️ تأكد من تعديل المسارات حسب هيكلة مشروعك
// import { store } from '@store/index'; 
// import { refreashToken } from '@store/Login/loginSlice'; // الـ Thunk الذي أرسلته لي

// // -----------------------------------------------------------------------------
// // 1. دالة مساعدة لقراءة AuthUser بأمان من localStorage
// // -----------------------------------------------------------------------------
// const getAuthUser = () => {
//   try {
//     const raw = localStorage?.AuthUser;
//     if (!raw) return null;
//     return JSON.parse(DecryptString(raw));
//   } catch (error) {
//     // يمكن تفعيل هذا السطر أثناء التطوير فقط
//     // console.warn('Error reading AuthUser from localStorage', error);
//     return null;
//   }
// };

// // -----------------------------------------------------------------------------
// // 2. إعداد Axios Instance
// // -----------------------------------------------------------------------------
// export const ntxAPI = axios.create({
//   baseURL: variables.API_URL,
//   headers: variables.ntxheader,
//   withCredentials: true, // ضروري لإرسال واستقبال الكوكيز (Cookies)
// });

// // متغيرات للتحكم في عملية التحديث المتزامنة
// let isRefreshing = false;
// let refreshQueue: ((token: string) => void)[] = [];

// // -----------------------------------------------------------------------------
// // 3. Interceptor لمعالجة الطلبات وتجديد التوكن
// // -----------------------------------------------------------------------------
// ntxAPI.interceptors.request.use(async (req: any) => {
//   // نقرأ التوكن مباشرة من localStorage لضمان الحصول على أحدث نسخة
//   const authUser = getAuthUser();
//   const token = authUser?.token;

//   // إرفاق التوكن إذا وجد
//   if (token) {
//     req.headers = req.headers || {};
//     req.headers.Authorization = `Bearer ${token}`;
//   }

//   // إذا كان التوكن صالحاً، نمرر الطلب فوراً
//   // ملاحظة: تأكد أن isTokenValid تقوم بفحص تاريخ الانتهاء (Expiration) بشكل صحيح
//   if (isTokenValid()) {
//     return req;
//   }

//   // إذا كان التوكن غير صالح، نبدأ عملية التحديث
//   if (!isRefreshing) {
//     isRefreshing = true;

//     try {
//       // ✅ نستخدم الـ Thunk الموجود في الستور لتحديث التوكن
//       // نقوم بعمل unwrap للنتيجة للتعامل مع النجاح أو الفشل كـ Promise
//       const resultAction = await store.dispatch(refreashToken());

//       if (refreashToken.fulfilled.match(resultAction)) {
//         const newToken = resultAction.payload?.token;

//         if (newToken) {
//           // تحديث هيدر الطلب الحالي
//           if (req.headers) {
//             req.headers.Authorization = `Bearer ${newToken}`;
//           }
          
//           // تنفيذ جميع الطلبات المعلقة في الطابور بالتوكن الجديد
//           refreshQueue.forEach((resolve) => resolve(newToken));
          
//           return req;
//         }
//       } 
      
//       // إذا وصلنا هنا، فهذا يعني أن التحديث فشل (أو الـ Payload فارغ)
//       throw new Error('Refresh failed');

//     } catch (error) {
//       // ❌ في حالة فشل التحديث تماماً
//       console.error('Session expired or refresh failed:', error);
      
//       // إلغاء الطلب الحالي لمنع حدوث أخطاء متتالية
//       return Promise.reject(error);
//     } finally {
//       // إعادة تعيين المتغيرات وتنظيف الطابور
//       isRefreshing = false;
//       refreshQueue = [];
//     }
//   } else {
//     // ⏳ إذا كانت عملية التحديث جارية، نضع الطلب في الطابور
//     return new Promise((resolve) => {
//       refreshQueue.push((newToken: string) => {
//         if (req.headers) {
//           req.headers.Authorization = `Bearer ${newToken}`;
//         }
//         resolve(req);
//       });
//     });
//   }
// });

// // Response Interceptor (اختياري)
// // يفضل إضافته للتعامل مع حالات الـ 401 التي قد تحدث حتى بعد التحديث
// ntxAPI.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // إذا عاد الخادم بـ 401، نوجه للمستخدم لصفحة الدخول
//       // يمكن استخدام store.dispatch(logout()) هنا أيضاً
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );


import axios from 'axios';
import { variables } from './variables';
import { isTokenValid } from '../Helper/Helper';
import { DecryptString, EncryptString } from '../Helper/Encrypt/NtxEncrypt'; // تأكد أن EncryptString موجود عندك

// -----------------------------------------------------------------------------
// Helpers
// -----------------------------------------------------------------------------
const buildUrl = (base: string, path: string) =>
  base.replace(/\/+$/, '/') + path.replace(/^\/+/, '');

const getAuthUser = () => {
  try {
    const raw = localStorage?.AuthUser;
    if (!raw) return null;
    return JSON.parse(DecryptString(raw));
  } catch {
    return null;
  }
};

const setAuthUserLocal = (data: any) => {
  // دمج القديم + الجديد (عشان ما نفقد حقول موجودة باللوكال)
  const prev = getAuthUser() || {};
  const merged = { ...prev, ...data };

  // نفس نمطك: تخزين مشفر
  localStorage.AuthUser = EncryptString(JSON.stringify(merged));
};

const refreshAccessTokenDirect = async (): Promise<string> => {
  const stored = getAuthUser();

  const accessToken = stored?.token;
  const businessGroupId = stored?.businessGroupId ?? null;

  if (!accessToken) throw new Error('NO_ACCESS_TOKEN');

  const url = buildUrl(variables.API_URL, 'Authenticate/refresh-token');

  const { data } = await axios.post(
    url,
    { accessToken, businessGroupId },
    {
      withCredentials: true,
      headers: {
        ...(variables.ntxheader || {}),
        // TenantId: stored?.tenantId ?? 'NTX', // خله ديناميكي إن توفر، وإلا الافتراضي
        'x-skip-refresh': '1',                // مهم لتفادي أي Loop
      },
    }
  );

  // خزّن التوكن الجديد باللوكال (لأن interceptor يقرأ من اللوكال)
  setAuthUserLocal(data);

  if (!data?.token) throw new Error('REFRESH_NO_TOKEN');
  return data.token as string;
};

// -----------------------------------------------------------------------------
// Axios instance
// -----------------------------------------------------------------------------
export const ntxAPI = axios.create({
  baseURL: variables.API_URL,
  headers: variables.ntxheader,
  withCredentials: true,
});

let isRefreshing = false;
type QueueItem = { req: any; resolve: (r: any) => void; reject: (e: any) => void };
let refreshQueue: QueueItem[] = [];

// -----------------------------------------------------------------------------
// Request interceptor
// -----------------------------------------------------------------------------
ntxAPI.interceptors.request.use(async (req: any) => {
  const authUser = getAuthUser();
  const token = authUser?.token;

  req.headers = req.headers || {};

  // تجاوز refresh/login لو احتجت
  const url = String(req?.url ?? '').toLowerCase();
  const skipRefresh =
    req.headers['x-skip-refresh'] === '1' ||
    url.includes('authenticate/refresh-token') ||
    url.includes('/login') ||
    url.includes('authenticate/login');

  // attach token (إن وجد)
  if (token) req.headers.Authorization = `Bearer ${token}`;

  if (skipRefresh) return req;

  // لو التوكن صالح خلاص
  if (isTokenValid()) return req;

  // لو ما يوجد token أصلاً، لا تحاول refresh
  if (!token) return req;

  // لو فيه refresh جاري، صفّ الطلب
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      refreshQueue.push({ req, resolve, reject });
    });
  }

  // ابدأ refresh
  isRefreshing = true;
  try {
    const newToken = await refreshAccessTokenDirect();

    // حدّث الطلب الحالي
    req.headers.Authorization = `Bearer ${newToken}`;

    // مرّر جميع الطلبات المعلقة
    refreshQueue.forEach((q) => {
      q.req.headers = q.req.headers || {};
      q.req.headers.Authorization = `Bearer ${newToken}`;
      q.resolve(q.req);
    });

    return req;
  } catch (error) {
    // ارفض جميع الطلبات المعلقة
    refreshQueue.forEach((q) => q.reject(error));

    // فشل refresh => رجّع المستخدم لتسجيل الدخول
    window.location.href = '/login';
    return Promise.reject(error);
  } finally {
    isRefreshing = false;
    refreshQueue = [];
  }
});

// -----------------------------------------------------------------------------
// Response interceptor
// -----------------------------------------------------------------------------
ntxAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
